module.exports = 15000;



// WEBPACK FOOTER //
// ./src/js/ot/publisher/max_delay.js